import firebase from "firebase";

import { developmentConfig } from "../config/dev";
import { productionConfig } from "../config/prod"

var firebaseApp = firebase.initializeApp(productionConfig);

const auth = firebase.auth();
auth.setPersistence(firebase.auth.Auth.Persistence.LOCAL)

export default firebaseApp;



// WEBPACK FOOTER //
// ./src/redux/config/firebase.js